<h3>Defaults</h3>
<mat-hint>These settings apply to all cards that get imported. You can change specific cards by previewing and adjusting the value for that card.</mat-hint>
<br>
<br>
<div *ngIf="mode === 'inventory'">
    <mat-form-field>
        <mat-select value="Played">
            <mat-option
                    *ngFor="let quality of ['Mint', 'Near Mint', 'Excellent', 'Good', 'Light Played', 'Played', 'Poor']"
                    [value]="quality"
                    (onSelectionChange)="onDefaultQualityChanged($event.source.value)"
            >{{quality}}</mat-option>
        </mat-select>
        <mat-label>Default Quality</mat-label>
    </mat-form-field>
    <br>
    <mat-hint>The default "quality" that you want to set the cards to.</mat-hint>
    <br>
    <mat-checkbox [(ngModel)]="defaultFoil">Is Foil?</mat-checkbox>
    <br>
    <mat-hint>Marks whether the card is foil or not.</mat-hint>
</div>
<div *ngIf="mode === 'deck'">
    <mat-checkbox [(ngModel)]="defaultOwned">Is Owned?</mat-checkbox>
    <br>
    <mat-hint>If checked, the importer will add the matching card from your inventory (if it exists).</mat-hint>
    <br>
    <mat-checkbox [(ngModel)]="defaultImportIntoInventory">Add to Inventory</mat-checkbox>
    <br>
    <mat-hint>If checked, the importer will also import the card into your inventory.</mat-hint>
</div>
<br>
<editor [init]="configuration()" [(ngModel)]="source" (onChange)="validate()"></editor>
<div class="progress-bar">
    <mat-progress-bar *ngIf="loadingData" mode="query"></mat-progress-bar>
</div>
<mat-error *ngFor="let error of errors">{{error}}</mat-error>
<div class="hints">
    <mat-hint>Use '#' to search all cards</mat-hint>
    <br>
    <mat-hint>Use '@' to search the cards in your inventory</mat-hint>
    <br>
    <mat-hint *ngIf="delimiter !== ' '">Use '!' to search sets</mat-hint>
    <br>
</div>
<div *ngIf="cardsToImport.length" class="preview">
    <h3>Preview</h3>
    <app-simple-table [availableColumns]="cardColumns" tableId="importer"
                      [tableDataContainer]="cardsToImport"
                      sortColumnId="name"
                      sortDirection="asc"
                      (cardSwapped)="swapCards($event)"
                      (editableFieldChanged)="fieldChanged($event)"
                      [swappableCards]="true"
                      [removableCards]="false"
                      [addCardsToDeck]="false"
                      [addCardsToInventory]="false"></app-simple-table>
    <mat-paginator [length]="totalCount"
                   (page)="pageChanged($event)"
                   pageSize="5"
                   showFirstLastButtons></mat-paginator>
</div>
